import $ from "jquery";

export function unloadingView(name) {
  //$.unblockUI();
  if ($("#" + name).length) {
    $("#" + name).remove();
  } else {
    console.log("Remove loading dosent exist name:" + name);
  }
}
export async function loadingView(name, img, message, blockui_inside, callback) {
  //console.log('loadingView', name);



  if (img === undefined || img === null) {
    img = "busy.gif";
  }
  var widthCss = "100%";
  const height = "150px";
  if (name === "personnalisation") {
    // widthCss = "35%";
  }
  let message_chargement = '<div id="' + name + '" class="LoadingAjaxImage">';
  message_chargement += '<img id="loadingImg" src="/modules/oryx/views/img/' + img + '" />';
  message_chargement += '<span class="span_blockui_message">' + message + '</span>';
  message_chargement += "</div>";

  if (blockui_inside !== undefined && blockui_inside !== null) {
    $(message_chargement).insertAfter(blockui_inside);
    console.log("block inser after specific div : " + blockui_inside);
  } else {

    $("body").append(message_chargement);
    //console.log('width element ', $('.LoadingAjaxImage img').width(), name)
    $("#" + name).css({
      position: "fixed",
      margin: 0,
      top: ($(window).height() - 244) / 2 + "px",
      borderRadius: "0.5rem",
      textAlign: "center",
      color: "#000",
      cursor: "wait",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    });
    //console.log("insert bloc de chargement dans en bas du body");
  }


  return new Promise(function (resolve, reject) {


    if (typeof callback === "function") {
      //var checkExist = setInterval(function () {
      if ($("#" + name).length) {
        //console.log(callback(name));
        callback(name);
        //clearInterval(checkExist);
        //console.log('resolve loadingView callBack', name);
        resolve();
      }
      //}, 100);
    }
    else {
      //console.log('resolve loadingView', name);
      resolve();
    }
  });
}
